// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__mLD_C","item":"PaymentsMobile_item__2DcNR","label":"PaymentsMobile_label__2ho8y","amount":"PaymentsMobile_amount__1ds2H"};